var _excluded = ["children", "name", "version", "viewBox", "xmlns", "fill"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Svg } from '@kizi/core-components';
import React from 'react';
import mapIcons from '../svgs/mapIcons';
export var Icon = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      name = _ref.name,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? '1.1' : _ref$version,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      _ref$xmlns = _ref.xmlns,
      xmlns = _ref$xmlns === void 0 ? 'http://www.w3.org/2000/svg' : _ref$xmlns,
      fill = _ref.fill,
      svgProps = _objectWithoutProperties(_ref, _excluded);

  var id = "Icons-".concat(name);
  var path = mapIcons[name];
  return /*#__PURE__*/React.createElement(Svg, _extends({
    ref: forwardedRef,
    "data-testid": "icon",
    version: version,
    viewBox: viewBox,
    xmlns: xmlns
  }, svgProps), children, /*#__PURE__*/React.createElement("title", null, id), /*#__PURE__*/React.createElement("g", {
    id: "--\uD83D\uDDBC-Icons",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: id
  }, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: path,
    id: "\uD83C\uDFA8-Icon-style"
  }))));
});